import IikoTransportOrganization from "./IikoTransport/IikoTransportOrganization";
import IikoTransportTerminalGroup from "./IikoTransport/IikoTransportTerminalGroup";
import IikoTransportPayment from "./IikoTransport/IikoTransportPayment";
import IikoTransportServers from "./IikoTransport/IikoTransportServers";
import IikoTransportExternalMenu from "./IikoTransport/IikoTransportExternalMenu";

const iikoTransport = ({ value, setValue, setIikoServer }) => {
    return (
        <>
            <IikoTransportServers setIikoServer={setIikoServer} />
            <div className="col-span-1 col-start-1">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">iiko Api Login</label>
                <input type="text"
                       value={value}
                       onChange={(e) => setValue(e.target.value)}
                       className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
            </div>

            <IikoTransportOrganization />
            <IikoTransportTerminalGroup />
            <IikoTransportPayment />
            <IikoTransportExternalMenu />
        </>
    )
}



export default iikoTransport
